import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const BackToTopWrapper = styled.div`
  position: fixed;
  height: 48px;
  bottom: 24px;
  right: 24px;
  @media (${mediaQuery.mobile}) {
    right: 16px;
    bottom: 16px;
  }
  svg {
    &:hover {
      cursor: pointer;
    }
    circle:hover {
      fill: #f7f8f9;
    }
  }
`;
